// extracted by mini-css-extract-plugin
export default {"titlePages":"title_titlePages__0-9wA","back":"title_back__IlBpB"};